import React, { useEffect, useState } from 'react'
import MainLoader from './components/MainLoader'
import { Button, Grid, TextField, Typography } from '@mui/material'
import Sidebar from './components/Sidebar'
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useLocation, useNavigate } from 'react-router'
import i18next from 'i18next';
import noDataFound from "../src/assests/images/no-report-ic.svg";
import { postApi } from './api/services';
import moment from 'moment';
import SyncIcon from '@mui/icons-material/Sync';
import imgurl from './assests/images/imgurl';
import { serviceDown } from './utils/UtilityFunctions';
import SearchIcon from "@mui/icons-material/Search";

const DoctorPrescriptionsList = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const [isLoading, setIsLoading] = useState(false)
  const [dataList, setDataList] = useState([])
  const [tempDataList, setTempDataList] = useState([])
  const [isRotating, setIsRotating] = useState(false);

  useEffect(() => {
    getPrescription()
  }, [])

  const getPrescription = async () => {
    try {
      setIsLoading(true)
      let params = {
        // user_id: 141
        user_id: location.state?.user_obj?.user_id
      }
      console.log("get_user_prescriptions params", params);
      const res = await postApi('get_user_prescriptions', params)
      if(res){
        console.log("get_user_prescriptions res", res);
        setDataList(res?.prescriptions)
        setTempDataList(res?.prescriptions)
        setIsLoading(false)
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown()
    }
  }

  const openPrescription = async (e, data) => {
    try {
      setIsLoading(true)
      let params = {
        slipid: data.prescription_number
      }
      console.log("get_prescriptions_by_slipid params", params);
      const res = await postApi('get_prescriptions_by_slipid', params)
      if(res){
        setIsLoading(false)
        console.log("get_prescriptions_by_slipid res", res);    
        navigate('/userprescription', {state: 
          {
            prescription: res?.prescriptions[0]?.patient_prescription, 
            user_obj: location.state?.user_obj, 
            prescribed_medicine: data?.prescribed_medicine,
            file_type: data?.file_type
          }
        })
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown()
    }
  }

  const handleRotate = () => {
    setIsRotating(true);  
    getPrescription()
  };

  const searchPrescription = async (value) => {
    const query = value.trim();
    if(!query){
      setDataList(tempDataList)
      return
    } else {
      let filteredArr = tempDataList.filter((pObj) => 
        pObj?.prescription_number?.toUpperCase().includes(query.toUpperCase())
      )
      console.log("filteredArr", filteredArr);
      setDataList(filteredArr)
    }
  }

  return (
    <>
      {isLoading && <MainLoader/>}
      <div className="photo-container main-section-container prescription-page doctor">
        <Grid
          container
          spacing={0}
          className="d-flex justify-content-start align-items-center header"
        >
          <Grid item xs={1} className="">
            <div className="d-flex justify-content-start align-items-center">
              <span
                className="backButtonDiv"
                onClick={() => navigate('/clients')}
              >
                <ArrowBackOutlinedIcon className="arrowBackBtn"></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid>
          <Grid
            item
            xs={9}
            className="d-flex justify-content-center align-items-center reportPageHead"
          >
            <Typography variant="h6" className="title ml-0px">
              {i18next.t("Prescriptions")}
            </Typography>
          </Grid>
          <Grid item xs={1} onClick={handleRotate} className="cursor-pointer">
            <SyncIcon className={isRotating ? "rotate-once" : ""} />
          </Grid>
          <Grid item xs={1}>
            <Sidebar />
          </Grid>
        </Grid>
        {
          dataList?.length > 0 &&
            <Grid container spacing={0} className="d-flex justify-content-center align-items-center searchDiv mt-5px mb-10px">
              <Grid item xs={12} className="d-flex justify-content-end align-items-center">
                <TextField
                  type="search"
                  className="searchInput w-100"
                  onChange={(e) => searchPrescription(e.target.value)}
                  placeholder={i18next.t("Enter name to search")}
                  InputProps={{
                    startAdornment: <SearchIcon className=" mr-5px" />
                  }}
                />
              </Grid>
            </Grid>
        }
        {
          dataList?.length > 0 ? 
            <div className='prescription_main_holder'>
              {
                dataList.map((data) => {
                  return(
                    <div 
                      className="prescriptionCard cursor-pointer"
                      key={data.prescription_id}
                      onClick={(e) => openPrescription(e, data)}
                    >
                      <Grid container spacing={2} className="prescriptionCardMain">
                        <Grid item xs={2} className="iconContainer">
                          <img src={imgurl.prescriptionIcon} className="prescriptionIcon"/>
                        </Grid>
                        <Grid item xs={7} className="prescriptionInfo">
                          <p className="mb-0 prescriptionId">{`${i18next.t("Dr")}. ${data?.doctor_name}`}</p>
                          <p className="mb-0 prescriptionDate">{`${i18next.t("Prescription ID")}: ${data?.prescription_number}`}</p>
                          <p className="mb-0 prescriptionDate">{`${moment(data?.prescription_date).format("LL")}`}</p>
                        </Grid>
                        <Grid item xs={3} className="prescriptioninfodiv">
                          {
                            data.status != "valid" ?
                              <div className="expired">
                                <Typography >
                                  {i18next.t("Expired")}
                                </Typography> 
                              </div>
                                :
                              <div className="active">
                                <Typography >
                                  {i18next.t("Active")}
                                </Typography> 
                              </div>
                          }
                        </Grid>
                      </Grid>
                    </div>
                  )
                })
              }
            </div> 
              :
            <div className="nodatadiv">
              <div className="nodatafoundimg">
                <img src={noDataFound} />
              </div>
              <Typography className="">
                {i18next.t("No prescriptions available")}
              </Typography>
            </div>
        }
        {
          dataList?.length > 0 &&
          <Button className='commonButton mt-15px' onClick={() => navigate('/prescriptions', {state: {user_obj: location.state?.user_obj}})}>
            {i18next.t("Add New Prescription")}
          </Button>
        }
      </div>
    </>
  )
}

export default DoctorPrescriptionsList